import { render, staticRenderFns } from "./BookMetaEditForm.vue?vue&type=template&id=ddf46660&"
import script from "./BookMetaEditForm.vue?vue&type=script&lang=js&"
export * from "./BookMetaEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports